export const placeholderText = "placeholder.Write a little about yourself";

export const newPostPlaceholderText = "placeholder.You can write anything";

export function getExampleIntroduction(language) {
    switch (language) {
        case "ja":
            return "こんにちは、俺の名は＿、";
        case "de":
            return "Hallo mein Name ist ＿, und meine Hobbies sind ＿";
        case "zh":
            return "你好，我叫＿，我的愛好是＿";
        case "en":
            return "Hello, my name is ＿, and my hobbies are ＿";
        case "es":
            return "Hola, mi nombre es ＿ y mis aficiones son ＿";
        case "fr":
            return "Bonjour, je m'appelle ＿ et mes hobbies sont ＿";
        default:
            return "";
    }
}



// WEBPACK FOOTER //
// ./src/utils/placeholder.js